import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone, faArrowRightFromBracket, faEllipsisVertical, faTrash, faQrcode, faStar, faDownload, faUsers, faPenToSquare, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import { HtmlEditor } from '../shared/htmlEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TimeFromDate from '../shared/TimeFromDate';
import DownloadCSV from '../shared/DownloadCSV';
import { CSVLink, CSVDownload } from "react-csv";
import DataTable from 'react-data-table-component';
import {
    UncontrolledDropdown, DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import EventRegistrationsRow from './EventRegistrationRow';

export default function EventRegistrations(props) {
    const { eventData } = props;
    const apiFetch = useApiFetch();

    const [loading, setLoading] = useState(false);
    const [registrations, setRegistrations] = useState([]);
    const [passes, setPasses] = useState([]);

    const [modal, setModal] = useState(false);

    const [validated, setValidated] = useState(false);

    const modalToggle = () => {
        if (!modal) {
            getData();
        }
        setModal(!modal);
        setValidated(false);
    };

    useEffect(() => {
        //setLoading(true);
    }, []);

    const getData = async () => {
        let registrations = null;
        await apiFetch.get('/api/event/' + encodeURIComponent(eventData.id) + '/registrations')
            .then(resp => {
                setRegistrations(resp.data);
                registrations = resp.data;
                setLoading(false);

                let passes = null;
                apiFetch.get('/api/event/' + encodeURIComponent(eventData.id) + '/pass')
                    .then(respp => {
                        setPasses(respp.data);
                        passes = respp.data;

                        registrations.forEach((r, i) => {

                            let regPassIx = passes.findIndex(p => p.registrationId === r.id && p.eventGuestId === null);
                            if (passes && regPassIx > -1) {
                                r.eventPass = passes.at(regPassIx);
                            }

                            //Now get all the guests in the registration and assign passess to them
                            r.eventGuests.forEach((eg, ii) => {
                                eg.eventPass = passes.find(p => p.registrationId === r.id && p.eventGuestId === eg.id);
                            });
                        });


                        setRegistrations(registrations);
                        setLoading(false);
                    });
            });


    };
    const updatedPasses = (reg, updPasses) => {

        if (reg && updPasses) {
            let regPassIx = updPasses.findIndex(p => p.registrationId === reg.id && p.eventGuestId === null);
            if (regPassIx > -1) {
                reg.eventPass = updPasses.at(regPassIx);
            }

            //Now get all the guests in the registration and assign passess to them
            reg.eventGuests.forEach((eg, ii) => {
                eg.eventPass = updPasses.find(p => p.registrationId === reg.id && p.eventGuestId === eg.id);
            });

            let clonePasses = [...passes];
            updPasses.forEach(p => {
                var thisIx = clonePasses.findIndex(cp => cp.id === p.id);
                if (thisIx >= 0) {
                    clonePasses[thisIx] = p;
                }
            });
            setPasses([...clonePasses]);


            let clone = [...registrations];
            let regIx = clone?.findIndex(x => x.id === reg.id);
            if (regIx >= 0) {
                clone[regIx] = reg;
            }
            setRegistrations([...clone]);

        }

    };
    const registrationDeleted = (id) => {

        let clone = [...registrations];
        let ix = clone.findIndex(r => r.id === id);
        if (ix >= 0) {
            clone.splice(ix, 1);
            setRegistrations([...clone]);
        }
    };
    return (
        <>
            <FontAwesomeIcon icon={faUsers} title='View Registrations' className='text-primary lh-1 px-1' size="lg" style={{ cursor: 'pointer' }} onClick={modalToggle} />
            <Modal isOpen={modal} toggle={modalToggle} size="xl" fade={true}>
                <ModalHeader toggle={modalToggle}>
                    <FontAwesomeIcon icon={faCalendar} className="pe-2" />Event Registrations
                </ModalHeader>
                <ModalBody className="table-responsive" style={{ display: 'block', width: '100%', overflowX: 'auto', maxHeight: 'calc(-124px + 100vh)' }}>
                    <ol className="list-group breadcrumb me-auto float-end">
                        <li className="breadcrumb-item">
                            <CSVLink data={registrations ? registrations.flatMap(r => {
                                const registrant = {
                                    email: r.email,
                                    firstName: r.firstName,
                                    lastName: r.lastName,
                                    company: r.company,
                                    phone: r.phone,
                                    dateRegistered: moment.utc(r.dateCreated).local().format("M/D/yyyy h:mm:ss A"),
                                    isGuest: false,
                                };

                                const guests = (r.eventGuests || []).map(guest => ({
                                    email: guest.email,
                                    firstName: guest.firstName,
                                    lastName: guest.lastName,
                                    company: guest.company, // fallback if guest has no company
                                    phone: guest.phone,
                                    dateRegistered: moment.utc(guest.dateCreated).local().format("M/D/yyyy h:mm:ss A"),
                                    isGuest: true
                                }));

                                return [registrant, ...guests];
                            }) : null} headers={[
                                { label: "Email", key: "email" },
                                { label: "First", key: "firstName" },
                                { label: "Last", key: "lastName" },
                                { label: "Company", key: "company" },
                                { label: "Phone", key: "phone" },
                                { label: "Date Registered", key: "dateRegistered" },
                                { label: "Is Guest", key: "isGuest" }
                                ]} className="link-primary-emphasis fw-semibold text-decoration-none" filename="RegistrationData">
                                <FontAwesomeIcon icon={faDownload} className="pe-2" />
                                Download Data
                            </CSVLink>
                        </li>
                    </ol>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="pe-3">Registrations: <span className="fw-semibold">{registrations && registrations.length}</span></li>
                            <li className="pe-3">Guests: <span className="fw-semibold">{registrations
                                ? registrations.reduce((count, registration) => {
                                    return count + (registration.eventGuests ? registration.eventGuests.length : 0);
                                }, 0)
                                : 0}</span></li>
                            <li className="">Total Attendees: <span className="fw-semibold">{registrations
                                ? registrations.length + registrations.reduce((count, registration) => {
                                    return count + (registration.eventGuests ? registration.eventGuests.length : 0);
                                }, 0)
                                : 0}</span></li>
                        </ol>
                    </nav>
                    <div className="table-responsive"
                        style={{
                            "display": "block", "width": "100%", "overflowY": "auto", "msOverflowStyle": "-ms-autohiding-scrollbar", "maxHeight": "calc(100vh - 225px)"
                        }}>
                        <table className="table table-sm table-hover mb-0">
                            <thead className="table-dark" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                <tr>
                                    <th colSpan="1">&nbsp;</th>
                                    <th>Email</th>
                                    <th>First</th>
                                    <th>Last</th>
                                    <th>Company</th>
                                    <th>Phone</th>
                                    <th className="text-center">Date Registered</th>
                                </tr>
                            </thead>
                            {registrations && registrations.length > 0 ?
                                registrations.map((r, i) =>
                                    <EventRegistrationsRow registration={r} key={i} passesUpdated={updatedPasses} registrationDeleted={registrationDeleted} eventData={eventData} />
                                )
                                :
                                <tbody>
                                    <tr>
                                        <td colSpan="6" className="text-center">There are no registration records.</td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                {/*    <table className="table table-sm table-hover">*/}
                {/*        <thead>*/}
                {/*            <tr>*/}
                {/*                <th>Email</th>*/}
                {/*                <th>First</th>*/}
                {/*                <th>Last</th>*/}
                {/*                <th>Company</th>*/}
                {/*                <th>Phone</th>*/}
                {/*                <th className="text-center">Date Registered</th>*/}
                {/*            </tr>*/}
                {/*        </thead>*/}
                {/*        <tbody>*/}
                {/*            {registrations && registrations.length > 0 ?*/}
                {/*                registrations.map((r, i) => */}
                {/*                    <tr key={i}>*/}
                {/*                        <td>{r.email}</td>*/}
                {/*                        <td>{r.firstName}</td>*/}
                {/*                        <td>{r.lastName}</td>*/}
                {/*                        <td>{r.company}</td>*/}
                {/*                        <td>{r.phone}</td>*/}
                {/*                        <td className="text-center"><TimeFromDate date={r.dateCreated} /></td>*/}
                {/*                    </tr>*/}
                {/*                )*/}
                {/*                :*/}
                {/*                <tr>*/}
                {/*                    <td colSpan="6" className="text-center">There are no registration records.</td>*/}
                {/*                </tr>*/}
                {/*                }*/}
                {/*        </tbody>*/}
                {/*    </table>*/}
                </ModalBody>
                {/*<ModalFooter>*/}
                {/*    <Button color="secondary" onClick={modalToggle}>*/}
                {/*        */}{/*<FontAwesomeIcon icon={faFloppyDisk} spin={false} className="me-2" />*/}
                {/*        Cancel*/}
                {/*    </Button>*/}
                {/*    <Button color="primary" onClick={modalToggle}>*/}
                {/*        <FontAwesomeIcon icon={faFloppyDisk} spin={false} className="me-2" />*/}
                {/*        Save*/}
                {/*    </Button>*/}
                {/*</ModalFooter>*/}
            </Modal>
        </>
    );
};
